import React from "react";
import { useTranslation } from "react-i18next";
import { EXTRA_SERVICE_TYPE, formatExtraServiceDate } from "./extraService";

const rowsFor = (trip, t) => [
  ["date", t("customerPortal.date"), formatExtraServiceDate(trip?.date) || trip?.date || ""],
  ["origin", t("customerPortal.tripOrigin"), trip?.origin || ""],
  ["destination", t("customerPortal.tripDestination"), trip?.destination || ""],
  ["departureTime", t("customerPortal.tripDeparture"), trip?.departureTime || ""],
  ["returnTime", t("customerPortal.tripReturn"), trip?.returnTime || ""],
  ["headcount", t("customerPortal.tripHeadcount"), trip?.headcount || ""],
];

const ExtraServiceFacts = ({ request, className = "" }) => {
  const { t } = useTranslation();
  if (!request || request.type !== EXTRA_SERVICE_TYPE || !request.extraService) return null;
  const rows = rowsFor(request.extraService, t).filter(([, , value]) => String(value || "").trim());
  if (rows.length === 0) return null;
  return (
    <dl className={`cp-meta cp-meta--stack cp-trip ${className}`.trim()}>
      {rows.map(([key, label, value]) => (
        <div key={key}>
          <dt>{label}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>
  );
};

export default ExtraServiceFacts;
